import styled from 'styled-components';
import { Theme } from '@/theme';

export const PopupContent = styled.div`
  background: ${Theme.color.white};
  position: relative;
  width: 100%;
`;

export const Triangle = styled.div`
  position: absolute;
  top: -40px;
  left: 31%;
  transform: translateX(-50%);
  width: 20px;
  height: 17px;
  background: ${Theme.color.white};
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
`;

export const Title = styled.h1`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(20)};
  line-height: ${Theme.rems(17)};
  font-weight: ${Theme.font.weight.bold};
  margin-bottom: 16px;
  text-transform: uppercase;
`;

export const Description = styled.p`
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(16)};
  line-height: 1.2;
  margin-bottom: ${Theme.rems(16)};
`;

export const StepperLabel = styled.p`
  color: ${Theme.color.darkGrey};
  font-size: ${Theme.rems(16)};
  line-height: 1.2;
  margin-bottom: 4px;
`;

export const Stepper = styled.div`
  align-items: center;
  border: 2px solid ${Theme.color.disabled};
  border-radius: 30px;
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  gap: 10px;
  height: 52px;
  margin-bottom: ${Theme.rems(20)};
  padding: 6px;
  width: 100%;
`;

export const StepperButton = styled.button`
  align-items: center;
  background-image: radial-gradient(
    50% 50% at 50% 50%,
    #ea282e 0%,
    #b80a0a 100%
  );
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 0 0 rgb(0 0 0 / 0.3) inset;
  color: ${Theme.color.orange};
  cursor: pointer;
  display: flex;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(32)};
  font-weight: ${Theme.font.weight.bold};
  height: 40px;
  justify-content: center;
  line-height: 1;
  padding: 0 0 4px;
  width: 40px;

  &:disabled {
    background: ${Theme.color.lightGrey};
    box-shadow: none;
    color: ${Theme.color.disabled};
    cursor: default;
  }
`;

export const StepperValue = styled.span`
  color: #595959;
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(28)};
  font-weight: ${Theme.font.weight.bold};
  line-height: 1;
  text-align: center;
`;

export const Button = styled.button`
  background: none;
  border: none;
  font-size: ${Theme.rems(18)};
  color: ${Theme.color.darkGrey};
  font-weight: ${Theme.font.weight.regular};
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  display: block;
`;
